import * as ko from 'knockout';

export class PaginationKnockoutModel {
  public page = ko.observable<number>(0);

  public resultsPerPage = ko.observable<number>(50);

  public totalPages = ko.observable<number>(0);

  public totalResults = ko.observable<number>(0);

  public rangeStart = ko.observable<number>(0);

  public rangeEnd = ko.observable<number>(0);

  private maxVisibleNumbers = 3; // 3 in each direction so 0,1,2,[3],4,5,6 if we are on page 3

  public setContentRange(contentRangeHeader: ContentRangeHeader) {
    this.rangeStart(contentRangeHeader.rangeStart);
    this.rangeEnd(contentRangeHeader.rangeEnd);
    this.totalResults(contentRangeHeader.size);
    this.totalPages(Math.ceil(contentRangeHeader.size / this.resultsPerPage()));
  }

  public navigatePage(page: number) {
    this.page(page);
  }

  public visiblePageNumbers = ko.pureComputed({
    read: (): Array<number> => {
      const visibleRanges: Array<number> = [];

      for (
        let i = this.page() - this.maxVisibleNumbers;
        i <= this.page() + this.maxVisibleNumbers;
        i += 1
      ) {
        if (i >= 0 && i < this.totalPages()) {
          visibleRanges.push(i);
        }
      }
      return visibleRanges;
    },
    deferEvaluation: true,
  });

  public isFirstPage = ko.pureComputed({
    read: (): boolean => this.page() == 0,
    deferEvaluation: true,
  });

  public isLastPage = ko.pureComputed({
    read: (): boolean => this.page() == this.totalPages() - 1,
    deferEvaluation: true,
  });

  public nextPageIsLastPage = ko.pureComputed({
    read: (): boolean => this.page() == this.totalPages() - 2,
    deferEvaluation: true,
  });

  public hasMoreNextVisiblePages = ko.pureComputed({
    read: (): boolean => this.page() + this.maxVisibleNumbers < this.totalPages() - 1,
    deferEvaluation: true,
  });

  public hasMorePreviousVisiblePages = ko.pureComputed({
    read: (): boolean => this.page() - this.maxVisibleNumbers > 0,
    deferEvaluation: true,
  });

  public lastPageNumber = ko.pureComputed({
    read: (): number => this.totalPages() - 1,
    deferEvaluation: true,
  });

  public previousPageIsFirstPage = ko.pureComputed({
    read: (): boolean => this.page() - 1 == 0,
    deferEvaluation: true,
  });

  public nextInSetOfPageNumbers = ko.pureComputed({
    read: (): number => this.page() + this.maxVisibleNumbers + 1,
    deferEvaluation: true,
  });

  public previousInSetOfPageNumbers = ko.pureComputed({
    read: (): number => this.page() - this.maxVisibleNumbers,
    deferEvaluation: true,
  });
}
export class ContentRangeHeader {
  public unit: string;

  public rangeStart: number;

  public rangeEnd: number;

  public size: number;

  public static fromString(contentRange: string): ContentRangeHeader {
    const contentRangeGroups = /^bytes ([0-9]+)-([0-9]+)\/([0-9]+)$/g.exec(contentRange);

    const contentRangeHeader = new ContentRangeHeader();
    contentRangeHeader.rangeStart = Number.parseInt(contentRangeGroups[1], 10);
    contentRangeHeader.rangeEnd = Number.parseInt(contentRangeGroups[2], 10);
    contentRangeHeader.size = Number.parseInt(contentRangeGroups[3], 10);

    return contentRangeHeader;
  }
}
